import http from '@/api/common'

export default {
  getServiceRequests(searchOptions) {
    return http.get('serviceRequest/GetServiceRequests', {
      params: searchOptions
    })
  },
  backDateServiceRequest(workOrder) {
    return http.get(`serviceRequest/AdjustWorkOrderCreatedDate?workOrderId=${workOrder}`)
  },
  getServiceRequestsWithMessages(searchOptions) {
    return http.get('serviceRequest/ServiceRequestsForList', {
      params: searchOptions
    })
  },
  getServiceRequestsForList(searchOptions) {
    return http.get('serviceRequest/ServiceRequestsForList', {
      params: searchOptions
    })
  },
  getServiceRequest(id) {
    return http.get(`serviceRequest/ServiceRequest?id=${id}`)
  },
  getServiceRequestHistory(id) {
    return http.get(`serviceRequest/GetServiceRequestHistory?id=${id}`)
  },
  getServiceRequestIssues(id) {
    return http.get(`issue/GetIssues?&status=ByRequest&searchTerm=${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/servicerequest.js